import { LinkItem } from '../models/LinkItem';
import { PageType } from '../models/Page';
import { getAdoRepoUrl } from '../../AGSS/util/BuildUtils';
import {
    getAdoAccountUrl,
    getAdoProjectUrl,
} from '../../Common/util/RouteUtils';

export const buildADOBreadcrumbTrail = (
    account: string,
    project: string,
    repoName: string
): LinkItem[] => {
    const items: LinkItem[] = [];
    //account
    items.push({
        text: account,
        href: getAdoAccountUrl(account),
        iconName: PageType.Account,
    });
    //project
    items.push({
        text: project,
        href: getAdoProjectUrl(account, project, ''),
        iconName: PageType.Project,
    });
    if (repoName) {
        //repoName
        items.push({
            text: repoName,
            href: getAdoRepoUrl(account, project, repoName),
            iconName: PageType.Repo,
        });
    }
    return items;
};
